import styled from 'styled-components';

export const Wrapper = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-top: 80px;

	@media (max-width: 992px) {
		flex-direction: column-reverse;
	}
`;

export const Left = styled.div`
	width: 50%;
	display: flex;
	justify-content: flex-start;

	img {
		max-width: 570px;
		width: 100%;
	}

	@media (max-width: 992px) {
		width: 100%;
		margin-top: 32px;
		text-align: center;
		justify-content: center;
	}
`;

export const Right = styled.div`
	width: 50%;

	@media (max-width: 992px) {
		width: 100%;
		text-align: center;
		display: flex;
		flex-direction: column;
		align-items: center;
	}
`;
export const Title = styled.h2`
	color: ${({ theme }) => theme.colors.text.title};
	font-size: 48px;
	font-weight: 700;
	line-height: 1.2;

	@media (max-width: 992px) {
		font-size: 32px;
	}
`;

export const Description = styled.p`
	color: $text-subtitle;
	font-size: 20px;
	font-weight: 400;
	margin: 20px 0;
	line-height: 1.2;

	@media (max-width: 992px) {
		font-size: 18px;
		margin: 16px 0;
	}
`;
